import { render, staticRenderFns } from "./ServizioDatiServizio.vue?vue&type=template&id=41f09026&"
import script from "./ServizioDatiServizio.vue?vue&type=script&lang=ts&"
export * from "./ServizioDatiServizio.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports